import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Navigation } from './navigation.component';
import { AuthActions, selectIsSignedIn } from '../../../../modules/auth';
import { selectHomeRoute } from '../../../../modules/headerBar';
import { selectFooterLinks } from '../../../../modules/footer';
import { selectMagazine } from '../../../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  isSignedIn: selectIsSignedIn,
  currentHomeRoute: selectHomeRoute,
  footerLinks: selectFooterLinks,
  magazine: selectMagazine,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showModal: AuthActions.showModal,
      signOut: AuthActions.signOut,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Navigation);
